<template>
  <v-card class="item" :to="to" height="100%" flat tile>
    <img
      class="d-block pa-3 pa-md-8 item-img"
      :src="img + '?resize=1&w=300'"
      width="100%"
    />

    <div class="py-4">
      <div class="secondary--text text-body-2 text-center font-weight-bold">
        {{ title }}
      </div>

      <div
        v-if="parsedBrand.length"
        class="d-flex align-center justify-center flex-wrap mt-3 item-brands"
      >
        <template v-for="({ id, title }, keyItems) in parsedBrand">
          <v-sheet
            :key="id + title"
            v-if="keyItems > 0"
            class="mx-1 mx-md-2"
            color="grey"
            height="12px"
            width="2px"
          ></v-sheet>
          <div
            :key="title"
            class="
              secondary--text
              text--lighten-2 text-caption text-center
              font-weight-medium
            "
          >
            {{ title }}
          </div>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    brand: [Array, String],
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    parsedBrand() {
      if (!this.brand || !this.brand.length) return [];

      return this.brand;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  aspect-ratio: 270 / 170;
  border: 1px solid #e2e8ea;
  -o-object-fit: contain;
  object-fit: contain;
}

.item-brands {
  column-gap: 10px;
}
</style>
